'use client';

import { c as _c } from "react/compiler-runtime";
import { Divider } from '@common/components';
import { SvgChevronleft, SvgFilter, SvgMagnifyingGlass, SvgTextfieldclose } from '@common/icon';
import { cn } from '@core/utils';
import { type FormEvent, useEffect, useRef, useState } from 'react';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { useSubscribedState } from '@/hooks/useSubscribedState';
import { useHideOnScroll } from './_hooks/useHideOnScroll';
import type { SearchScope } from './constants';
import { SearchCategoryDropdown } from './SearchCategoryDropdown';
interface SearchBarProps {
  keyword?: string;
  filterCount?: number;
  shouldAutoFocus?: boolean;
  /** 모바일에서 sticky + 스크롤시 자동 숨김 적용 여부. overlay 안에서는 false. */
  sticky?: boolean;
  /** 카테고리 노출 범위. 'donation'이면 고향사랑기부 카테고리만. 미지정 시 전체. */
  scope?: SearchScope;
  onSearch: (keyword: string) => void;
  onFilterClick?: () => void;
  /** input의 focus/blur 신호를 부모에 전파한다. 미지정 시 동작 없음. */
  onFocusChange?: (focused: boolean) => void;
  //* 미지정 시 라우터 back — 입력 레이어 안에서는 레이어 닫기로 갈아탄다.
  onBack?: () => void;
}
export function SearchBar(t0) {
  const $ = _c(58);
  const {
    keyword: t1,
    filterCount: t2,
    shouldAutoFocus: t3,
    sticky: t4,
    scope,
    onSearch,
    onFilterClick,
    onFocusChange,
    onBack
  } = t0;
  const keyword = t1 === undefined ? "" : t1;
  const filterCount = t2 === undefined ? 0 : t2;
  const shouldAutoFocus = t3 === undefined ? false : t3;
  const sticky = t4 === undefined ? true : t4;
  const router = useCustomRouter();
  const inputRef = useRef(null);
  const [value, setValue] = useSubscribedState(keyword);
  const [isFocused, setIsFocused] = useState(false);
  let t5;
  if ($[0] !== sticky) {
    t5 = {
      enabled: sticky
    };
    $[0] = sticky;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const {
    hidden
  } = useHideOnScroll(t5);
  let t6;
  let t7;
  if ($[2] !== shouldAutoFocus) {
    t6 = () => {
      if (shouldAutoFocus) {
        inputRef.current?.focus();
      }
    };
    t7 = [shouldAutoFocus];
    $[2] = shouldAutoFocus;
    $[3] = t6;
    $[4] = t7;
  } else {
    t6 = $[3];
    t7 = $[4];
  }
  useEffect(t6, t7);
  let t8;
  if ($[5] !== onSearch || $[6] !== value) {
    t8 = e => {
      e.preventDefault();
      onSearch(value.trim());
    };
    $[5] = onSearch;
    $[6] = value;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const handleSubmit = t8;
  let t9;
  if ($[8] !== setValue) {
    t9 = () => {
      setValue("");
      inputRef.current?.focus();
    };
    $[8] = setValue;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  const handleClear = t9;
  let t10;
  if ($[10] !== onFocusChange) {
    t10 = focused => {
      setIsFocused(focused);
      onFocusChange?.(focused);
    };
    $[10] = onFocusChange;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  const handleFocusChange = t10;
  let t11;
  if ($[12] !== hidden || $[13] !== sticky) {
    t11 = sticky && ["mobile-tablet:sticky mobile-tablet:top-0 mobile-tablet:z-10 mobile-tablet:bg-Gray-white", "mobile-tablet:transition-transform mobile-tablet:duration-200", hidden && "mobile-tablet:-translate-y-full"];
    $[12] = hidden;
    $[13] = sticky;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== t11) {
    t12 = cn("flex w-full flex-col items-center", t11);
    $[15] = t11;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== onBack || $[18] !== router) {
    t13 = () => onBack ? onBack() : router.back();
    $[17] = onBack;
    $[18] = router;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <SvgChevronleft className="size-24 text-Gray-900" />;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== t13) {
    t15 = <button type="button" aria-label={"\uB4A4\uB85C \uAC00\uAE30"} className="hidden shrink-0 mobile-tablet:flex" onClick={t13}>{t14}</button>;
    $[21] = t13;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== scope) {
    t16 = <SearchCategoryDropdown scope={scope} />;
    $[23] = scope;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <Divider variant="vertical" className="h-20 shrink-0 bg-Gray-400" />;
    $[25] = t17;
  } else {
    t17 = $[25];
  }
  let t18;
  if ($[26] !== t16) {
    t18 = <div className="flex shrink-0 items-center mobile-tablet:min-w-0 mobile-tablet:max-w-100 mobile-tablet:shrink mobile-tablet:overflow-hidden">{t16}{t17}</div>;
    $[26] = t16;
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  let t19;
  if ($[28] !== setValue) {
    t19 = e_0 => {
      setValue(e_0.target.value);
    };
    $[28] = setValue;
    $[29] = t19;
  } else {
    t19 = $[29];
  }
  let t20;
  let t21;
  if ($[30] !== handleFocusChange) {
    t20 = () => handleFocusChange(true);
    t21 = () => handleFocusChange(false);
    $[30] = handleFocusChange;
    $[31] = t20;
    $[32] = t21;
  } else {
    t20 = $[31];
    t21 = $[32];
  }
  let t22;
  if ($[33] !== t19 || $[34] !== t20 || $[35] !== t21 || $[36] !== value) {
    t22 = <input ref={inputRef} type="text" value={value} onChange={t19} onFocus={t20} onBlur={t21} placeholder={"\uAC80\uC0C9\uC5B4\uB97C \uC785\uB825\uD558\uC138\uC694"} className="flex-1 bg-transparent text-Gray-900 outline-none typo-body3 placeholder:text-Gray-550 mobile-tablet:min-w-0 mobile-tablet:tracking-[-0.28px] mobile-tablet:typo-body4" />;
    $[33] = t19;
    $[34] = t20;
    $[35] = t21;
    $[36] = value;
    $[37] = t22;
  } else {
    t22 = $[37];
  }
  let t23;
  if ($[38] !== handleClear || $[39] !== isFocused || $[40] !== value.length) {
    t23 = value.length > 0 && <button type="button" aria-label={"\uC9C0\uC6B0\uAE30"} className={cn("shrink-0 p-4 mobile-tablet:-m-8 mobile-tablet:p-8", !isFocused && "mobile-tablet:hidden")} onMouseDown={_temp} onClick={handleClear}><SvgTextfieldclose className="size-20 mobile-tablet:size-16" originalFill={true} /></button>;
    $[38] = handleClear;
    $[39] = isFocused;
    $[40] = value.length;
    $[41] = t23;
  } else {
    t23 = $[41];
  }
  let t24;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <button type="submit" aria-label={"\uAC80\uC0C9"} className="h-40 w-56 shrink-0 rounded-pill bg-Gray-black flex-center mobile-tablet:hidden"><SvgMagnifyingGlass className="size-20 text-Gray-white" /></button>;
    $[42] = t24;
  } else {
    t24 = $[42];
  }
  let t25;
  if ($[43] !== handleSubmit || $[44] !== t18 || $[45] !== t22 || $[46] !== t23) {
    t25 = <form role="search" onSubmit={handleSubmit} className="flex h-48 flex-1 items-center gap-12 rounded-pill border border-Gray-300 py-12 pl-16 pr-4 mobile-tablet:h-40 mobile-tablet:min-w-0 mobile-tablet:gap-12 mobile-tablet:text-clip mobile-tablet:rounded-xsmall mobile-tablet:border-0 mobile-tablet:bg-Gray-200 mobile-tablet:p-8">{t18}{t22}{t23}{t24}</form>;
    $[43] = handleSubmit;
    $[44] = t18;
    $[45] = t22;
    $[46] = t23;
    $[47] = t25;
  } else {
    t25 = $[47];
  }
  let t26;
  if ($[48] !== filterCount || $[49] !== onFilterClick) {
    t26 = onFilterClick ? <button type="button" aria-label={"\uD544\uD130"} className="hidden shrink-0 items-center gap-4 mobile-tablet:flex" onClick={onFilterClick}><SvgFilter className="size-20 text-Gray-900" />{filterCount > 0 && <span className="flex size-16 items-center justify-center rounded-pill bg-Gray-black font-700 text-Gray-white typo-caption2">{filterCount}</span>}</button> : null;
    $[48] = filterCount;
    $[49] = onFilterClick;
    $[50] = t26;
  } else {
    t26 = $[50];
  }
  let t27;
  if ($[51] !== t15 || $[52] !== t25 || $[53] !== t26) {
    t27 = <div className="flex w-full items-center mobile-tablet:gap-10 mobile-tablet:overflow-hidden mobile-tablet:px-20 mobile-tablet:py-4">{t15}{t25}{t26}</div>;
    $[51] = t15;
    $[52] = t25;
    $[53] = t26;
    $[54] = t27;
  } else {
    t27 = $[54];
  }
  let t28;
  if ($[55] !== t12 || $[56] !== t27) {
    t28 = <div className={t12}>{t27}</div>;
    $[55] = t12;
    $[56] = t27;
    $[57] = t28;
  } else {
    t28 = $[57];
  }
  return t28;
}
function _temp(event) {
  return event.preventDefault();
}